import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { SectionHeader } from "@/components/shared/Common";
import { Lock, ChevronRight, MessageSquare, FileText, ShieldCheck } from "lucide-react";

const STATUS_LABEL = {
  started: "Negotiation Started",
  awaiting_response: "Awaiting Response",
  terms_agreed: "Terms Agreed",
  contract_accepted: "Contract Accepted",
  deployment_confirmed: "Deployment Confirmed",
  completed: "Job Completed",
  reviewed: "Performance Reviewed",
};

export default function MyNegotiations() {
  const [rooms, setRooms] = useState(null);

  useEffect(() => {
    api.get("/negotiations").then((r) => setRooms(r.data || []))
       .catch((e) => { toast.error(formatApiError(e.response?.data?.detail)); setRooms([]); });
  }, []);

  return (
    <div className="space-y-6">
      <SectionHeader
        eyebrow="Secure communication"
        title="My negotiation rooms"
        subtitle="All conversations, contract edits and signatures live inside SecuSource. No personal phone numbers or emails are exchanged."
      />
      {rooms === null && <div className="text-white/60 font-manrope text-sm">Loading…</div>}
      {rooms?.length === 0 && (
        <div className="card-flat p-10 text-center">
          <Lock className="w-8 h-8 text-white/50 mx-auto mb-3" />
          <div className="font-outfit font-semibold text-white mb-1">No active negotiations.</div>
          <div className="text-sm text-white/60 font-manrope">Open a room from any professional profile to begin a secure, in-platform negotiation.</div>
        </div>
      )}
      <div className="grid gap-3">
        {(rooms || []).map((r) => (
          <Link key={r.id} to={`/negotiations/${r.id}`} className="card-flat p-5 border-l-4 border-l-brand hover:border-l-brand-hover" data-testid={`my-negot-${r.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-xs uppercase tracking-widest text-brand font-outfit font-bold flex items-center gap-1"><Lock className="w-3.5 h-3.5" /> {STATUS_LABEL[r.status] || r.status}</div>
                <div className="font-outfit font-bold text-white truncate">{r.subject}</div>
                <div className="text-xs text-white/60 font-manrope mt-1">Updated {new Date(r.updated_at).toLocaleString()}</div>
              </div>
              <ChevronRight className="w-5 h-5 text-white/50 flex-shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
